import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import './LanguageSwitcher.css'

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const { i18n: {changeLanguage, language} } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(language)

    const handleLanguageChange = (newLanguage) => {
        setCurrentLanguage(newLanguage);
        changeLanguage(newLanguage);
    }

    return (
        <div className="language-switcher">
            <span
                style={{
                    fontWeight: i18n.language === "en" ? "bold" : "normal",
                }}
                onClick={() => handleLanguageChange("en")}
            >
                EN
            </span>
            |
            <span
                style={{
                    fontWeight: i18n.language === "el" ? "bold" : "normal",
                }}
                onClick={() => handleLanguageChange("el")}
            >
                ΕΛ
            </span>
        </div>
    );
};

export default LanguageSwitcher;
